<div class="w-100" >
  <div [formGroup]="form">
    <app-common-checkbox  [formControl]="modifyBrowserFlags">
      <span class="checkbox-label">{{ 'modify_browser_flags' | translate }}</span>
    </app-common-checkbox>
    <div *ngIf="modifyBrowserFlags?.value && browserFlags?.value?.length" class="ms-5">
      <ul class="d-flex flex-column gap-3 list-unstyled">
        @for (flag of browserFlags?.value; track flag) {
          <li class="d-flex align-items-center font-size-s font-weight-500">
            <span class="me-3">{{ flag }}</span>
            <button
              class="remove-flag-button ds-btn-micro-action ds-btn eap-red-error"
              id="remove-flag-button"
              type="button"
              (click)="removeBrowserFlag(flag)"
            >
              <ds-icon class="me-1" [icon]="Icons.CircleMinus"></ds-icon>
              {{ 'remove_browser_flag' | translate }}
            </button>
          </li>
        }
      </ul>
    </div>
  </div>
  <div [formGroup]="newBrowserFlagForm" class="ms-5">
    <div class="row gx-2">
      <div class="col-8 col-lg-6">
        <app-common-input
          
          [form]="newBrowserFlagForm"
          [context]="{ label: 'add_browser_flag', field: newBrowserFlagControlName }"
          [formValidationRequest$]="browserFlagsValidationRequest$"
          (input)="onNewBrowserFlagInput($event.target.value)"
        />
      </div>
      <div class="col-4 col-lg-3">
        <button
          ds-button
          class="add-browser-flag-button"
          
          [variant]="DsButtonVariants.primary"
          type="submit"
          (click)="addNewBrowserFlag()"
        >
          {{ 'add_browser_flag_button' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
